<template>
  <v-container fluid class="ma-0 pa-0 d-flex justify-center">
    <v-container class="ma-0 pa-2 settings-container">
      <v-card outlined>
        <v-card-title class="align-start">
          <div>
            <div class="text-h6">
              Einstellungen
            </div>
            <div class="text-caption text--secondary font-weight-regular mt-1">
              Verwalten Sie Kundendaten, Rechnungen und angebundene Dienste nach Themen geordnet.
            </div>
          </div>
        </v-card-title>

        <v-divider></v-divider>

        <v-tabs
          v-model="aktiverBereich"
          show-arrows
          aria-label="Einstellungsbereiche"
        >
          <v-tab href="#allgemein">
            <v-icon left small>
              mdi-tune
            </v-icon>
            Allgemein
          </v-tab>
          <v-tab href="#pdf-rechnungen">
            <v-icon left small>
              mdi-file-document-outline
            </v-icon>
            PDF &amp; Rechnungen
          </v-tab>
          <v-tab
            v-if="darfMailEinstellungenVerwalten"
            href="#mail"
          >
            <v-icon left small>
              mdi-email-outline
            </v-icon>
            E-Mail
          </v-tab>
          <v-tab
            v-if="darfApiZugriffVerwalten"
            href="#api"
          >
            <v-icon left small>
              mdi-api
            </v-icon>
            API
          </v-tab>
        </v-tabs>

        <v-divider></v-divider>

        <v-tabs-items v-model="aktiverBereich">
          <v-tab-item value="allgemein">
            <v-card flat>
              <v-card-text class="pa-4 pa-sm-6">
                <p class="text-subtitle-1 font-weight-medium mb-1">
                  Nutzergruppe der Kunden
                </p>
                <p class="text-caption text--secondary mb-2">
                  Nutzer, die der folgenden Nutzergruppe zugeordnet sind, werden
                  als Kunden behandelt.
                </p>
                <v-select
                  v-model="save.settings.id_nutzergruppe_kunde"
                  :items="$store.state.main.save.nutzergruppen"
                  item-value="id"
                  item-text="name"
                  label="Nutzergruppe"
                  class="pt-0"
                />

                <v-divider class="my-5"></v-divider>

                <p class="text-subtitle-1 font-weight-medium mb-1">
                  Offline-Daten
                </p>
                <p class="text-caption text--secondary mb-0">
                  Erlaubt die Einsicht ohne Netzwerkverbindung. Die Kundendaten werden dazu
                  lokal auf dem Gerät des Benutzers gespeichert und beim Ausloggen gelöscht.
                </p>
                <v-checkbox
                  v-model="save.settings.dataOffline"
                  label="Offline-Zugriff auf Kundendaten für berechtigte Nutzer erlauben"
                  hide-details
                ></v-checkbox>

                <div
                  v-if="xChanged.settings"
                  class="d-flex justify-end mt-6"
                >
                  <v-btn
                    small
                    color="success"
                    :loading="isSaving"
                    @click="allgemeineEinstellungenSpeichern"
                  >
                    <v-icon left>
                      mdi-content-save
                    </v-icon>
                    Allgemeine Einstellungen speichern
                  </v-btn>
                </div>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item value="pdf-rechnungen">
            <v-card flat>
              <v-card-text class="pa-4 pa-sm-6">
                <RechnungshintergrundEinstellungen />
                <RechnungsnummerEinstellungen />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item
            v-if="darfMailEinstellungenVerwalten"
            value="mail"
          >
            <v-card flat>
              <v-card-text class="pa-4 pa-sm-6 settings-tab-content">
                <MailEinstellungen
                  :document-types="prop_settings.auftraegeDokumentarten || []"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item
            v-if="darfApiZugriffVerwalten"
            value="api"
          >
            <v-card flat>
              <v-card-text class="pa-4 pa-sm-6 settings-tab-content">
                <ApiZugriff />
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-card>
    </v-container>
  </v-container>
</template>

<script>
import ApiZugriff from '@/components/Funktionen/400/410-Kunden/ApiZugriff.vue';
import MailEinstellungen from '@/components/Funktionen/400/410-Kunden/MailEinstellungen.vue';
import RechnungshintergrundEinstellungen from './RechnungshintergrundEinstellungen.vue';
import RechnungsnummerEinstellungen from './RechnungsnummerEinstellungen.vue';

export default {
  components: {
    ApiZugriff,
    MailEinstellungen,
    RechnungshintergrundEinstellungen,
    RechnungsnummerEinstellungen,
  },
  props: {
    prop_settings: {
      type: Object,
      default() { return {}; },
    },
  },
  data: () => ({
    aktiverBereich: 'allgemein',
    xLoaded: {},
    xChanged: {},
    save: {
      settings: {},
    },
    isSaving: false,
  }),
  computed: {
    darfMailEinstellungenVerwalten() {
      const { save } = this.$store.state.main;
      return Boolean(
        save.user
        && Array.isArray(save.user.rechte)
        && save.user.rechte.includes('s|410|mail')
        && (save.user.rechte.includes('x') || save.user.rechte.includes('x|410|set')),
      );
    },
    darfApiZugriffVerwalten() {
      const { save } = this.$store.state.main;
      return Boolean(
        save.user
        && Array.isArray(save.user.rechte)
        && save.user.rechte.includes('x|410|set')
        && save.user.rechte.includes('s|410|api'),
      );
    },
  },
  watch: {
    prop_settings: {
      handler() {
        this.datenLaden();
      },
      deep: true,
    },
    save: {
      handler() {
        this.xChanged.settings = JSON.stringify(this.save.settings)
          !== JSON.stringify(this.xLoaded.settings);
      },
      deep: true,
    },
  },
  methods: {
    allgemeineEinstellungenSpeichern() {
      const einstellungen = JSON.parse(JSON.stringify(this.save.settings));
      // Alt gecachte Metadaten dürfen nie als allgemeine Einstellung gespeichert werden.
      delete einstellungen.invoiceBackground;
      this.saveSettings({ type: 'saveSettings', data: einstellungen });
    },
    saveSettings(data) {
      this.isSaving = true;
      this.$emit('tryGetOrSave', data);
    },
    datenLaden() {
      if (JSON.stringify(this.prop_settings) !== JSON.stringify(this.xLoaded.settings)) {
        this.save.settings = JSON.parse(JSON.stringify(this.prop_settings));
        this.xLoaded.settings = JSON.parse(JSON.stringify(this.prop_settings));
        this.isSaving = false;
      }
    },
  },
  created() {
    this.datenLaden();
  },
};
</script>

<style scoped>
.settings-container {
  max-width: 1100px;
}

.settings-tab-content ::v-deep > section,
.settings-tab-content ::v-deep > div {
  margin-top: 0 !important;
}

.settings-tab-content ::v-deep > section > .v-divider:first-child,
.settings-tab-content ::v-deep > div > .v-divider:first-child {
  display: none;
}
</style>
